import { render, staticRenderFns } from "./DashboardGrid.vue?vue&type=template&id=f0eb28a4&scoped=true"
import script from "./DashboardGrid.vue?vue&type=script&lang=js"
export * from "./DashboardGrid.vue?vue&type=script&lang=js"
import style0 from "./DashboardGrid.vue?vue&type=style&index=0&id=f0eb28a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0eb28a4",
  null
  
)

export default component.exports